import { useMutation } from '@tanstack/react-query';
import saveAs from 'save-as';

import { useToast } from 'Store/toast';
import { useLoader } from 'Store/loader';
import getExportReportAttendanceHost from 'Api/report-attendance/getExportReportAttendanceHost';
import { exportReportText } from 'Const/report-attendance/text';

import getExportReportAttendanceHostRequest from './model/request/getExportReportAttendanceHostRequest';

const useGetExportReportAttendanceHost = () => {
  const { onOpenToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();

  return useMutation({
    mutationFn: async (filter) => {
      onShowLoader({ variant: 'loader-primary' });

      const params = getExportReportAttendanceHostRequest(filter);

      const response = await getExportReportAttendanceHost(params);

      return { response };
    },
    onSuccess: ({ response }) => {
      const filename = `Report Attendance Host.xlsx`;

      const blob = new Blob([response]);

      saveAs(blob, filename);

      onOpenToast({
        status: 'success',
        description: exportReportText.successExportText,
        duration: 3,
        alwaysShow: false,
      });
    },
    onError: (error) => {
      console.log(error);

      onOpenToast({
        status: 'error',
        description: exportReportText.failedExportText,
        duration: 5,
        alwaysShow: false,
      });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default useGetExportReportAttendanceHost;
